export const RefreshToSeeUpdatedDate = 'If necessary, refresh the page to see the updated date.';
